module.exports = __webpack_public_path__ + "static/media/HiBob-logo.89851e3d.png";